import React from 'react'
import { Link } from 'react-router-dom';
import homeIMG from  '../../Assets/Home.png'
import Navbar from '../Navbar/Navbar';
import {motion} from 'framer-motion'
import homeStyle from './Home.module.css';



    function Slider() {
      return (

        <>
        <Navbar/>

<motion.div
    initial={{width:0}}
    animate={{width:"100%"}}
    exit={{x: window.innerWidth, transition:{duration:0.1}}}
>
<div className= {` ${homeStyle.mainHome}  ` }  >
  <div className={`${homeStyle.mediaQ} container d-flex justify-content-around align-items-center h-100 ` }>
  <img className={`${homeStyle.animate} ${homeStyle.img}   `} src={homeIMG} alt="img" />
  <span>
  <h3 className='text-white '>Welcome to</h3>
  <h1 className={homeStyle.miniHome}>Gardenia House</h1>
  <h4>100% fresh beauty delivered.</h4>
  <button className='btn btn-lg btn-danger text-white'><Link className='text-white text-decoration-none' to="products">Shop Now</Link> </button>
</span>
</div></div></motion.div>

        </>
  );
    }

    export default Slider;



